/** WARNING: This file is generated automatically **/

import type { TrackingContextValue } from '../providers/TrackingContext';
import { getEntities } from '../utils/getEntities';
import { getGTMData } from '../utils/getGTMData';
import { trackSelfDescribingEvent } from '../utils/trackSelfDescribingEvent';

/**
 * Fires when a tab is clicked
 */
export interface TabClick {
  /**
   * the name of the tab
   */
  tabName: string;
}

export const tabClick = (data: Readonly<TabClick>, context?: TrackingContextValue) => {
  window.__GTM_DATA_LAYER__?.push({ event: 'tab_click', ...data, ...getGTMData(context) });

  trackSelfDescribingEvent(
    {
      event: {
        schema: 'iglu:com.starsgroup/tab_click/jsonschema/1-0-0',
        data
      },
      context: getEntities(context)
    },
    context
  );
};
